import { IVoucherSimulationConfigOutput } from ".";

export interface IVoucherSimulationConfigSummary {
    name: string,
    output: IVoucherSimulationConfigOutput[]
}